class n {
  axios;
  constructor(e) {
    this.axios = e;
  }
  async get(e, t, s) {
    return this.axios.get(e, { params: t, ...s }).then((i) => i.data);
  }
  async post(e, t, s) {
    return this.axios.post(e, t, s).then((i) => i.data);
  }
  async patch(e, t, s) {
    return this.axios.patch(e, t, s).then((i) => i.data);
  }
  async delete(e, t) {
    return this.axios.delete(e, t).then((s) => s.data);
  }
  async put(e, t, s) {
    return this.axios.put(e, t, s).then((i) => i.data);
  }
}
class p extends n {
  getLogs = async (e, t) => this.get("v1/analytics/logs", e, {
    paramsSerializer: {
      indexes: null
    },
    ...t
  });
}
class v extends n {
  getTokenPair = async (e, t) => this.post("v1/auth/auth0/token", e, t);
  refreshTokenPair = async (e, t) => this.post("v1/auth/token/refresh", e, t);
  generateCustomerToken = async (e, t) => this.post("v1/auth/generate-customer-token", e, t);
}
class h extends n {
  getScriptActions = async (e) => this.get("v1/script/actions", void 0, e);
}
class y extends n {
  getMyAccountLink = async (e) => this.get(
    "v2/customer/account-links/me",
    void 0,
    e
  );
  getCustomerAttributes = async (e, t) => this.get("v1/customer/attributes", e, t);
  getCustomerAttribute = async (e, t) => this.get(
    `v1/customer/attributes/name/${e}`,
    void 0,
    t
  );
  createCustomerAttribute = async (e, t) => this.post("v1/customer/attributes", e, t);
  updateCustomerAttribute = async (e, t, s) => this.put(`v1/customer/attributes/${e}`, t, s);
  updateCustomerAttributes = async (e, t) => this.patch("v1/customer/attributes", e, t);
  deleteCustomerAttribute = async (e, t) => this.delete(`v1/customer/attributes/${e}`, t);
  deleteAllCustomerAttributes = async (e) => this.delete("v1/customer/attributes", e);
  getCustomerSetting = async (e, t) => this.get(
    `v1/customer/settings/name/${e}`,
    void 0,
    t
  );
  setCustomerStatus = async (e, t, s) => this.post(`v1/customer/${e}/set-status`, t, s);
  cloneCustomer = async (e, t) => this.post("v2/customer", e, t);
  getCustomerAccountLinks = async (e, t) => this.get("v2/customer/account-links", e, t);
  createCustomerAccountLink = async (e, t) => this.post("v2/customer/account-links", e, t);
  exportCustomerSessionReportToEmail = async (e, t) => this.post("v1/customer/report/export-to-email", e, t);
  updateCustomerAccountLink = async (e, t, s) => this.patch(
    `v2/customer/account-links/${e}`,
    t,
    s
  );
  deleteCustomerAccountLink = async (e, t) => this.delete(`v2/customer/account-links/${e}`, t);
}
var u = /* @__PURE__ */ ((r) => (r.Admin = "admin", r.Member = "member", r))(u || {});
class m extends n {
  getAccountCustomers = async (e) => {
    const t = {
      ...e,
      paramsSerializer: {
        serialize: (s) => {
          const i = new URLSearchParams();
          return Object.entries(s).forEach(([a, o]) => {
            Array.isArray(o) ? o.forEach((c) => {
              i.append(a, String(c));
            }) : o != null && i.append(a, String(o));
          }), i.toString();
        }
      }
    };
    return this.get("v1/account/customers", e?.params, t);
  };
  getAdminViewFilteredCustomers = async (e) => this.get("v1/account/customers/export/csv", void 0, {
    responseType: "text",
    ...e
  });
  getAccount = async (e) => this.get("v1/account", void 0, e);
  unlinkCustomer = async (e, t) => {
    await this.delete(`v1/account/customer-links/${e}`, t);
  };
  updateCustomer = async (e, t, s) => this.patch(`v1/account/customers/${e}`, t, s);
  getApiKeys = async (e) => this.get("v1/account/member-api-keys", void 0, e);
  createApiKey = async (e, t) => this.post("v1/account/member-api-keys", e, t);
  deleteApiKey = async (e, t) => this.delete(`v1/account/member-api-keys/${e}`, t);
  updateApiKeyStatus = async (e, t, s) => this.patch(
    `v1/account/member-api-keys/${e}/status`,
    t,
    s
  );
}
class b extends n {
  createPersona = async (e, t) => this.post("v1/customer/personas", e, t);
  updatePersona = async (e, t, s) => this.patch(`v1/customer/personas/${e}`, t, s);
  deletePersona = async (e, t) => this.delete(`v1/customer/personas/${e}`, t);
  getPersonaActors = async (e, t, s) => this.get(
    `v1/customer/personas/${e}/actors`,
    t,
    s
  );
  createPersonaActor = async (e, t, s) => this.post(
    `v1/customer/personas/${e}/actors`,
    t,
    s
  );
  // Persona attributes
  getPersonaAttributes = async (e, t, s) => this.get(
    `v1/customer/personas/${e}/attributes`,
    t,
    s
  );
  createPersonaAttribute = async (e, t, s) => this.post(
    `v1/customer/personas/${e}/attributes`,
    t,
    s
  );
  updatePersonaAttribute = async (e, t, s, i) => this.put(
    `v1/customer/personas/${e}/attributes/${t}`,
    s,
    i
  );
  deletePersonaAttribute = async (e, t, s) => this.delete(
    `v1/customer/personas/${e}/attributes/${t}`,
    s
  );
}
class $ extends n {
  deleteUserActor = async (e, t) => this.delete(`v1/actors/user/${e}`, t);
}
var g = /* @__PURE__ */ ((r) => (r.USD = "usd", r.EUR = "eur", r.GBP = "gbp", r))(g || {});
const P = /* @__PURE__ */ new Map([
  ["usd", "$"],
  ["eur", "€"],
  ["gbp", "£"]
]);
class A extends n {
  getProfile = async (e) => this.get("v1/customer/profile", void 0, e);
  updateProfile = async (e, t) => this.patch("v1/customer/profile", e, t);
  getBilling = async (e) => this.get("v1/customer/billing", void 0, e);
  getBillingStripeUrl = async (e, t) => this.post("v1/customer/billing/get-stripe-url", e, t);
  getBillingCheckoutUrl = async (e, t) => this.post(
    "v1/customer/billing/generate-checkout-url",
    e,
    t
  );
  completeDevelopmentStage = async (e) => this.post(
    "v1/customer/billing/complete-development-stage",
    void 0,
    e
  );
  getBillingProducts = async (e, t) => this.get("v1/customer/billing/products", e, t);
}
class k extends n {
  getLLMProviders = async (e) => this.get("v1/providers", void 0, e);
  getLLMProviderKeys = async (e, t) => this.get(`v1/providers/${e}/keys`, void 0, t);
  createLLMKey = async (e, t, s) => this.post(`v1/providers/${e}/keys`, t, s);
  updateLLMKey = async (e, t, s) => this.patch(`v1/providers/keys/${e}`, t, s);
  deleteLLMKey = async (e, t) => this.delete(`v1/providers/keys/${e}`, t);
}
class f extends n {
  getAgent = async (e, t) => this.get(`v1/designer/agents/${e}`, void 0, t);
  createAgent = async (e, t, s) => this.post(`v2/designer/${e}/agents`, t, s);
  updateAgent = async (e, t, s) => this.patch(`v1/designer/agents/${e}`, t, s);
  deleteAgent = async (e, t) => this.delete(`v1/designer/agents/${e}`, t);
}
class I extends n {
  getStorageImages = async (e, t) => this.get(
    `v1/designer/storages/${e}/images`,
    void 0,
    t
  );
  deleteProjectImage = async (e, t, s) => this.delete(
    `v1/designer/storages/${e}/images/${t}`,
    s
  );
}
var d = /* @__PURE__ */ ((r) => (r.SKILL = "skill", r.EVENT = "event", r.FLOW = "flow", r.AGENT = "agent", r))(d || {});
class w extends n {
  getProjects = async (e) => this.get("v1/designer/projects", void 0, e);
  getProjectsSearch = async (e, t, s) => this.get(
    "v1/designer/projects/search",
    { query: e, ...t },
    s
  );
  getProject = async (e, t) => this.get(
    `v1/designer/projects/by-id/${e}`,
    void 0,
    t
  );
  createProject = async (e, t) => this.post("v1/designer/projects", e, t);
  updateProject = async (e, t, s) => this.patch(
    `v1/designer/projects/by-id/${e}`,
    t,
    s
  );
  deleteProject = async (e, t) => this.delete(`v1/designer/projects/by-id/${e}`, t);
  makeProjectImage = async (e, t, s) => this.post(
    `v1/designer/projects/by-id/${e}/make-image`,
    t,
    s
  );
  forceUpdateProject = async (e, t) => this.post(
    `v1/designer/projects/by-id/${e}/force-update`,
    void 0,
    t
  );
  publishProject = async (e, t, s) => this.post(
    `v1/designer/projects/${e}/publish`,
    t,
    s
  );
}
class j extends n {
  createProjectAttribute = async (e, t, s) => this.post(
    `v1/designer/projects/${e}/attributes`,
    t,
    s
  );
  updateProjectAttribute = async (e, t, s, i) => this.put(
    `v1/designer/projects/${e}/attributes/${t}`,
    s,
    i
  );
  deleteProjectAttribute = async (e, t, s) => this.delete(
    `v1/designer/projects/${e}/attributes/${t}`,
    s
  );
}
class x extends n {
  getProjectImageStorages = async (e) => this.get("v1/designer/storages", void 0, e);
  getProjectImageStorage = async (e, t) => this.get(`v1/designer/storages/${e}`, void 0, t);
}
class S extends n {
  getRegistries = async (e) => this.get("v1/designer/registries", void 0, e);
}
class C extends n {
  getRegistryItems = async (e, t) => this.get(
    `v1/designer/registries/${e}/items`,
    void 0,
    t
  );
  createRegistryItem = async (e, t, s) => this.post(
    `v1/designer/registries/${e}/items`,
    t,
    s
  );
  deleteRegistryItem = async (e, t, s) => this.delete(
    `v1/designer/registries/${e}/items/${t}`,
    s
  );
  publishRegistryItem = async (e, t, s) => this.post(
    `v1/designer/registries/${e}/items/${t}/publish`,
    void 0,
    s
  );
}
class L extends n {
  sendConnectorEvent = async (e, t) => this.post("v1/events/connector", e, t);
}
class F extends n {
  getAgentFlows = async (e, t) => this.get(
    `v1/designer/${e}/flows`,
    void 0,
    t
  );
  getFlow = async (e, t) => this.get(`v1/designer/flows/${e}`, void 0, t);
  createEmptyFlow = async (e, t, s) => this.post(`v1/designer/${e}/flows/empty`, t, s);
  createTemplateFlow = async (e, t, s) => this.post(
    `v1/designer/${e}/flows/from-template`,
    t,
    s
  );
  updateFlow = async (e, t, s) => this.patch(`v1/designer/flows/${e}`, t, s);
  deleteFlow = async (e, t) => this.delete(`v1/designer/flows/${e}`, t);
  publishFlow = async (e, t, s) => this.post(`v1/designer/flows/${e}/publish`, t, s);
  duplicateFlow = async (e, t, s) => this.post(
    `v1/designer/${e}/flows/duplicate`,
    t,
    s
  );
}
class V extends n {
  getFlowSkills = async (e, t) => this.get(
    `v1/designer/flows/${e}/skills`,
    void 0,
    t
  );
  createFlowSkill = async (e, t, s) => this.post(`v1/designer/flows/${e}/skills`, t, s);
  deleteFlowSkill = async (e, t) => this.delete(`v1/designer/flows/skills/${e}`, t);
  updateFlowSkill = async (e, t, s) => this.put(`v1/designer/flows/skills/${e}`, t, s);
  createSkillParameter = async (e, t, s) => this.post(
    `v1/designer/flows/skills/${e}/parameters`,
    t,
    s
  );
  deleteSkillParameter = async (e, t) => this.delete(
    `v1/designer/flows/skills/parameters/${e}`,
    t
  );
  updateSkillParameter = async (e, t, s) => this.put(
    `v1/designer/flows/skills/parameters/${e}`,
    t,
    s
  );
}
class B extends n {
  getLibraries = async (e, t) => this.get(
    `v1/designer/projects/${e}/libraries`,
    void 0,
    t
  );
  getLibrary = async (e, t, s) => this.get(
    `v1/designer/projects/${e}/libraries/${t}`,
    void 0,
    s
  );
  createLibrary = async (e, t, s) => this.post(
    `v1/designer/projects/${e}/libraries`,
    t,
    s
  );
  updateLibrary = async (e, t, s, i) => this.patch(
    `v1/designer/projects/${e}/libraries/${t}`,
    s,
    i
  );
  deleteLibrary = async (e, t, s) => this.delete(
    `v1/designer/projects/${e}/libraries/${t}`,
    s
  );
}
class T extends n {
  getLibrarySkills = async (e, t) => this.get(
    `v1/designer/libraries/${e}/skills`,
    void 0,
    t
  );
  createLibrarySkill = async (e, t, s) => this.post(
    `v1/designer/libraries/${e}/skills`,
    t,
    s
  );
  updateLibrarySkill = async (e, t, s, i) => this.patch(
    `v1/designer/libraries/${e}/skills/${t}`,
    s,
    i
  );
  deleteLibrarySkill = async (e, t, s) => this.delete(
    `v1/designer/libraries/${e}/skills/${t}`,
    s
  );
  createLibrarySkillParameter = async (e, t, s, i) => this.post(
    `v1/designer/libraries/${e}/skills/${t}/parameters`,
    s,
    i
  );
  deleteLibrarySkillParameter = async (e, t, s, i) => this.delete(
    `v1/designer/libraries/${e}/skills/${t}/parameters/${s}`,
    i
  );
  updateLibrarySkillParameter = async (e, t, s, i, a) => this.put(
    `v1/designer/libraries/${e}/skills/${t}/parameters/${s}`,
    i,
    a
  );
}
class E extends n {
  getFlowEvents = async (e, t) => this.get(
    `v1/designer/flows/${e}/events`,
    void 0,
    t
  );
  createFlowEvent = async (e, t, s) => this.post(`v1/designer/flows/${e}/events`, t, s);
  deleteFlowEvent = async (e, t) => this.delete(`v1/designer/flows/events/${e}`, t);
  updateFlowEvent = async (e, t, s) => this.patch(`v1/designer/flows/events/${e}`, t, s);
}
class K extends n {
  getFlowStates = async (e, t) => this.get(
    `v1/designer/flows/${e}/states`,
    void 0,
    t
  );
  createFlowState = async (e, t, s) => this.post(`v1/designer/flows/${e}/states`, t, s);
  updateFlowState = async (e, t, s) => this.put(`v1/designer/flows/states/${e}`, t, s);
  deleteFlowState = async (e, t) => this.delete(`v1/designer/flows/states/${e}`, t);
}
class M extends n {
  getFlowTemplates = async (e) => this.get("v1/designer/flow-templates", void 0, e);
}
class U extends n {
  getTopics = async (e, t) => this.get("v1/akb/topics", e, t);
  createTopic = async (e, t) => this.post("v1/akb/append-manual", e, t);
  updateTopic = async (e, t, s) => this.put(`v1/akb/topics/${e}`, t, s);
  deleteTopic = async (e, t) => this.delete(`v1/akb/topics/${e}`, t);
  deleteTopics = async (e, t) => this.post("v1/akb/topics/batch-delete", e, t);
  deletePersonaAKB = async (e, t) => this.delete(`v1/akb/personas/${e}`, t);
  exportAKB = async (e, t) => this.get("v1/akb/export", e, t);
  importAKB = async (e, t, s) => this.post(`v1/akb/import?persona_id=${e}`, t, s);
  importAKBFile = async (e, t, s) => this.post(`v1/akb/import/file?persona_id=${e}`, t, {
    ...s,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
  getAKBTasks = async (e, t) => this.get("v1/akb/tasks", e, t);
}
class _ extends n {
  getIntegrations = async (e) => this.get("v1/integrations", void 0, e);
  getIntegrationByIdn = async (e, t) => this.get(
    `v1/integrations/name/${e}`,
    void 0,
    t
  );
  getIntegrationSettings = async (e, t) => this.get(
    `v1/integrations/${e}/settings`,
    void 0,
    t
  );
  getIntegrationConnectors = async (e, t) => this.get(
    `v1/integrations/${e}/connectors`,
    void 0,
    t
  );
  getByIntegrationIdnConnectors = async (e, t) => this.get(
    `v1/integrations/by-idn/${e}/connectors`,
    void 0,
    t
  );
  getIntegrationConnectorIdns = async (e, t) => this.get(
    `v1/integrations/${e}/connectors/names`,
    void 0,
    t
  );
  getConnectorSettings = async (e, t) => this.get(
    `v1/integrations/connectors/${e}/settings`,
    void 0,
    t
  );
  changeIntegrationSettings = async (e, t, s) => this.post(
    `v1/integrations/${e}/settings`,
    t,
    s
  );
  createConnector = async (e, t, s) => this.post(
    `v1/integrations/${e}/connectors`,
    t,
    s
  );
  updateConnector = async (e, t, s) => this.patch(
    `v1/integrations/connectors/${e}`,
    t,
    s
  );
  deleteConnector = async (e, t) => this.delete(`v1/integrations/connectors/${e}`, t);
  launchConnector = async (e, t) => this.post(
    `v1/integrations/connectors/${e}/run`,
    void 0,
    t
  );
  stopConnector = async (e, t) => this.post(
    `v1/integrations/connectors/${e}/stop`,
    void 0,
    t
  );
  changeConnectorSettings = async (e, t, s) => this.post(
    `v1/integrations/connectors/${e}/settings`,
    t,
    s
  );
  getIntegrationConnectorByIdn = async (e, t, s) => this.get(
    `v1/integrations/${e}/${t}`,
    void 0,
    s
  );
}
class R extends n {
  getPossibleValues = async (e, t, s) => this.get(e, t, s);
}
class W extends n {
  // Attributes
  getCustomerAttributes = async (e, t) => this.get("v1/bff/customer/attributes", e, t);
  getPersonaAttributes = async (e, t, s) => this.get(
    `v1/bff/personas/${e}/attributes`,
    t,
    s
  );
  getPersonas = async (e, t) => this.get("v1/bff/personas/search", e, t);
  getPersona = async (e, t) => this.get(`v1/bff/personas/${e}`, void 0, t);
  // SESSIONS
  getSessions = async (e, t) => this.get("v1/bff/sessions", e, {
    paramsSerializer: {
      indexes: null
    },
    ...t
  });
  getSessionsInfo = async (e, t) => this.get("v1/bff/sessions/info", e, t);
  // AGENTS
  getAgentsList = async (e, t) => this.get("v1/bff/agents/list", e, t);
  getConversationsUserPersonas = async (e, t) => this.get("v1/bff/conversations/user-personas", e, {
    paramsSerializer: {
      indexes: null
    },
    ...t
  });
  getConversationsUserPersona = async (e, t) => this.get(
    `v1/bff/conversations/user-personas/${e}`,
    void 0,
    t
  );
  getConversationsActs = async (e, t) => this.get("v1/bff/conversations/acts", e, {
    paramsSerializer: {
      indexes: null
    },
    ...t
  });
  getConversationsConnectors = async (e) => this.get("v1/bff/conversations/connectors", void 0, e);
  // REGISTRY ITEMS
  getRegistryItemsGroupedByIdn = async (e, t, s) => this.get(
    `v1/bff/registries/${e}/items/grouped-by-idn`,
    t,
    s
  );
  getRegistryItemVersions = async (e, t, s, i) => this.get(
    `v1/bff/registries/by-idn/${e}/items/by-idn/${t}/versions`,
    s,
    i
  );
  // STORAGES
  getStorageImages = async (e, t, s) => this.get(`v1/bff/storages/${e}/images`, t, s);
  // PROJECT ATTRIBUTES
  getProjectAttributes = async (e, t, s) => this.get(
    `v1/bff/projects/${e}/attributes`,
    t,
    s
  );
  // WIDGETS
  getWidgets = async (e, t) => this.get("v1/bff/widgets/connectors", e, t);
}
class z extends n {
  updateSession = async (e, t, s) => this.patch(`v1/sessions/${e}`, t, s);
}
class O extends n {
  exportSuperAgent = async (e, t) => this.post("v2/designer/customer/export", e, {
    ...t,
    responseType: "blob"
  });
  importSuperAgent = async (e, t) => this.post("v2/designer/customer/import", e, t);
  exportSuperAgentV1 = async (e, t) => this.get("v1/init/export", e, {
    ...t,
    responseType: "blob"
  });
  importSuperAgentV1 = async (e, t, s) => {
    const i = t ? `?project_id=${t}` : void 0;
    return this.post(`v1/init/import${i}`, e, {
      ...s,
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  };
}
class D extends n {
  sendUserChatMessage = async (e, t, s) => this.post(`v1/chat/user/${e}`, t, s);
}
class G extends n {
  sendAgentChatMessage = async (e, t) => this.post("v1/conversations/agent-message", e, t);
}
class N extends n {
  createActor = async (e, t) => this.post(
    "talking-head/get-create-actor",
    { ...e, connector_idn: "newo_chat" },
    t
  );
  getSettings = async (e) => this.get("talking-head/chat-settings", {
    client_secret: e
  });
  sendActorEvent = async (e) => this.post("talking-head/send-actor-event", e);
  createPartnerOrganization = async ({
    customer: e,
    externalId: t,
    client_secret: s
  }) => {
    await this.sendActorEvent({
      client_secret: s,
      connector_idn: "newo_chat",
      external_id: t,
      event_idn: "onboarding_started",
      arguments: Object.keys(e).map((i) => ({
        name: i,
        value: e[i]
      })).concat([
        {
          name: "external_customer_id",
          value: t
        }
      ])
    });
  };
}
class q extends n {
  getWebhooks = async (e) => this.get("v1/webhooks", void 0, e);
  createWebhook = async (e, t) => this.post("v1/webhooks", e, t);
  updateWebhook = async (e, t, s) => this.patch(`v1/webhooks/${e}`, t, s);
  deleteWebhook = async (e, t) => this.delete(`v1/webhooks/${e}`, t);
  getIncomingWebhooks = async (e) => this.get("v1/webhooks/incoming", void 0, e);
  createIncomingWebhook = async (e, t) => this.post("v1/webhooks/incoming", e, t);
  updateIncomingWebhook = async (e, t, s) => this.patch(`v1/webhooks/incoming/${e}`, t, s);
  deleteIncomingWebhook = async (e, t) => this.delete(`v1/webhooks/incoming/${e}`, t);
}
class H extends n {
  getVoices = async (e, t) => this.get(
    `v1/voices?connector_idn=${e}`,
    void 0,
    t
  );
}
var l = /* @__PURE__ */ ((r) => (r.Pending = "pending", r.Published = "published", r.Validating = "validating", r))(l || {});
class J extends n {
  listProjectVersions = async (e, t) => this.get("v3/designer/project-versions", e, t);
  createProjectVersion = async (e, t) => this.post("v3/designer/project-versions", e, t);
  deleteProjectVersion = async (e, t) => this.delete(
    `v3/designer/project-versions/${e}`,
    t
  );
  updateProjectVersion = async (e, t, s) => this.patch(
    `v3/designer/project-versions/${e}`,
    t,
    s
  );
  publishProjectVersion = async (e, t) => this.post(
    `v3/designer/project-versions/${e}/publish`,
    void 0,
    t
  );
  mintFileAccessSession = async (e, t) => this.post(
    `v3/designer/project-versions/${e}/session`,
    void 0,
    t
  );
  createProjectVersionImportUrl = async (e) => this.post("v3/designer/project-versions/import-url", {}, e);
  completeProjectVersionImport = async (e, t) => this.post(
    "v3/designer/project-versions/import-url/complete",
    e,
    t
  );
  createProjectVersionExportUrl = async (e, t) => this.post(
    `v3/designer/project-versions/${e}/export-url`,
    void 0,
    t
  );
  createCustomerProjectsImportUrl = async (e) => this.post("v3/designer/customer/import-url", {}, e);
  completeCustomerProjectsImport = async (e, t) => this.post(
    "v3/designer/customer/import-url/complete",
    e,
    t
  );
  createCustomerProjectsExportUrl = async (e) => this.post("v3/designer/customer/export-url", void 0, e);
  listCustomerLinks = async (e, t) => this.get("v3/designer/customer-links", e, t);
  upsertCustomerLink = async (e, t) => this.post("v3/designer/customer-links", e, t);
  deleteCustomerLink = async (e, t) => this.delete(
    `v3/designer/customer-links/${e}`,
    t
  );
  listRegistries = async (e) => this.get("v3/designer/registries", void 0, e);
  listModules = async (e, t) => this.get(
    `v3/designer/registries/${e}/modules`,
    void 0,
    t
  );
  createModule = async (e, t, s) => this.post(
    `v3/designer/registries/${e}/modules`,
    t,
    s
  );
  publishModule = async (e, t, s) => this.post(
    `v3/designer/registries/${e}/modules/${t}/publish`,
    void 0,
    s
  );
  listModuleVersions = async (e, t, s, i) => this.get(
    `v3/designer/registries/by-idn/${e}/modules/by-idn/${t}/versions`,
    s,
    i
  );
  listProjects = async (e) => (await this.get(
    "v3/designer/projects",
    void 0,
    e
  )).items;
  getProject = async (e, t) => this.get(`v3/designer/projects/${e}`, void 0, t);
  createProject = async (e, t) => this.post("v3/designer/projects", e, t);
  updateProject = async (e, t, s) => this.patch(`v3/designer/projects/${e}`, t, s);
  deleteProject = async (e, t) => this.delete(`v3/designer/projects/${e}`, t);
}
export {
  U as AKBAPI,
  m as AccountAPI,
  u as AccountRole,
  $ as ActorsAPI,
  f as AgentsAPI,
  p as AnalyticsAPI,
  v as AuthorizationAPI,
  W as BFFAPI,
  D as ChatAPI,
  G as ConversationsAPI,
  g as Currency,
  y as CustomerAPI,
  J as DesignerV2API,
  L as EventsAPI,
  F as FlowAPI,
  E as FlowEventsAPI,
  V as FlowSkillsAPI,
  K as FlowStatesAPI,
  M as FlowTemplatesAPI,
  O as InitAPI,
  _ as IntegrationAPI,
  B as LibrariesAPI,
  T as LibrarySkillsAPI,
  N as NewoChatApi,
  b as PersonasAPI,
  R as PossibleValuesAPI,
  A as ProfileAPI,
  j as ProjectAttributesAPI,
  x as ProjectImageStoragesAPI,
  I as ProjectImagesAPI,
  l as ProjectVersionStatus,
  w as ProjectsAPI,
  k as ProvidersAPI,
  S as RegistriesAPI,
  C as RegistryItemsAPI,
  h as ScriptAPI,
  d as SearchEntityType,
  z as SessionsAPI,
  H as VoicesAPI,
  q as WebhooksAPI,
  P as currencySymbols
};
